import React from "react";
import { Card, Row, Col, OverlayTrigger, Tooltip, Placeholder } from "react-bootstrap";
import { isBoolean } from "@revbox/helpers-fe";
import { useCookiesContext } from "../../../contexts/CookiesContext";
import { auctionCampaignStatusCardLabels } from "@revbox/localization";
import appvizerLogo from "../../../assets/svg/appvizer-logo.svg";
import appvizerLogoWhite from "../../../assets/svg/appvizer-logo-white.svg";
import { useJoyride } from "../../../contexts/JoyrideContext";
import { memo } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";

function DefaultAuctionCampaignStatusCard(props) {
    const { campaign, campaignCategories, anyActiveSpecificBid, anyActiveBrandingBid, anyActiveClusterBid, isIframe = false, id } = props;
    const { getLanguageAbbr } = useCookiesContext();
    const { startPPCPageTourAfterPageChange } = useJoyride();
    const multilang = auctionCampaignStatusCardLabels[getLanguageAbbr()];
    const cardRef = useRef()
    const cond = !isBoolean(anyActiveBrandingBid) && !isBoolean(anyActiveClusterBid) && !isBoolean(anyActiveSpecificBid);

    if (cond) {
        return (
              <Placeholder
                as={Card.Title}
                animation="glow"
                style={{ color: "var(--bs-body-color)" }}
              >
                <Placeholder style={{ height: 145, width: "100%" }} />
              </Placeholder>
        );
    }

    const cardContent = (
        <Card className={`card-one ${isIframe ? 'iframe-card-background' : ''}`} id={id} ref={cardRef}>
                <Card.Body>
                    <Row>
                        <Col xs="12">
                            {campaign?.ppc_active && !campaign?.ppc_paused && (anyActiveSpecificBid || anyActiveBrandingBid || anyActiveClusterBid) && (
                                <h3 className="card-value fw-bold text-success mb-0">
                                {multilang.status.active}
                                </h3>
                            )}
                            {campaign?.ppc_active && !campaign?.ppc_paused && !anyActiveSpecificBid && !anyActiveBrandingBid && !anyActiveClusterBid && (
                                <h3 className="card-value fw-bold text-warning mb-0">
                                {multilang.status.not_bidding}
                                </h3>
                            )}
                            {!campaign?.ppc_active && !campaign?.ppc_paused && (
                                <h3 className="card-value fw-bold text-danger mb-0">
                                {multilang.status.inactive}
                                </h3>
                            )}
                            {campaign?.ppc_paused && (
                                <h3 className="card-value fw-bold text-warning mb-0">
                                {multilang.status.paused}
                                </h3>
                            )}
                            <label className="card-title fw-medium text-dark mb-1">
                                {multilang.status.label}
                            </label>
                        </Col>
                    </Row>
                </Card.Body>
                <Card.Footer style={{ height: '60px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Row>
                        {
                            isIframe && (
                                <Col xs="12">
                                    <span className="d-block fs-11 text-secondary lh-4">
                                        {multilang.categoriesPrefix}:{" "}
                                        {campaignCategories?.length > 2
                                        ? campaignCategories?.slice(0, 2).join(", ") +
                                            ", " +
                                            String(campaignCategories?.length - 2) +
                                            " " + multilang.moreSuffix
                                        : campaignCategories?.join(", ")}
                                    </span>
                                </Col>
                            )
                        }
                        {
                            !isIframe && (
                                <Col xs="12">
                                    <span className="d-block fs-11 text-secondary lh-4 inline-block" style={{display: "inline-block !important"}}>{multilang.targeting}</span>
                                    <a href="https://appvizer.com" target="_blank" rel="noopener noreferrer" className="me-3 websites-logo">
                                        <img src={appvizerLogo} className="logoClass" style={{height: "18px"}} />
                                        <img src={appvizerLogoWhite} className="logoDarkClass" style={{height: "18px"}} />
                                    </a>
                                </Col>
                            )
                        }
                    </Row>
                </Card.Footer>
            </Card>
    )

    if (isIframe) {
        return cardContent;
    }

    if (cardRef.current) {
      startPPCPageTourAfterPageChange()
    }

    return (
        <OverlayTrigger
            placement="bottom"
            overlay={
                campaign?.ppc_active || campaign?.ppc_paused ? (
                <Tooltip placement="bottom">
                    {multilang.tooltip.before} <strong>{multilang.tooltip.highlight}</strong> {multilang.tooltip.after}
                </Tooltip>
                ) : (
                <></>
                )
            }
        >
            {cardContent}
        </OverlayTrigger>
    )
}

export default memo(DefaultAuctionCampaignStatusCard)
